import { size } from '@styles/theme'
import { Link } from 'react-router-dom'

const PostRepostText = ({ isRepost, reposter }) => {
  if (isRepost) return (
    <div style={{ height: size(3.5), paddingBottom: size(1) }}>
      <Link style={{ color: 'grey', textDecoration: 'none', fontWeight: 700, fontSize: 14, display: 'flex', width: 'fit-content' }}>
        {reposter.displayName} reposted
      </Link>
    </div>
  )
}

export { PostRepostText }
